import { Routes } from '@angular/router'
import { ViewElectronicSOAComponent } from './components/view-soa.component'
import { SubmitElectronicSOAComponent } from './components/soa-form-submission.component'
import { ElectronicSOALayoutComponent } from './components/layout/electronic-soa-layout.component'
import { SOAViewEmailComponent } from './components/soa-view-email.component'
import { SOAViewReturnToAgentConfirmationComponent } from './components/soa-view-returntoagent-confirmation'
import { SOAFormSubmissionConfirmationComponent } from './components/soa-form-submission-confirmation'
import { SOAFormEmailLinkAgentSignedComponent } from './components/soa-form-email-link-agent-signed'
import { SOAFormEmailLinkAgentExpiredComponent } from './components/soa-form-email-link-agent-expired'
import { CanActivateGaurd } from '../auth/can-activate-gaurd'

export const routes: Routes = [
    {
        path: '',
        component: ElectronicSOALayoutComponent,
        children: [

            {
                path: 'viewsoa',
                component: ViewElectronicSOAComponent
            },
             {
                 path: 'submitsoa',
                 canActivate: [CanActivateGaurd],
                component: SubmitElectronicSOAComponent
            },
             {
                 path: 'viewsoaemailform/:accessCode',
                 component: SOAViewEmailComponent
            },
            {
                path: 'soaviewagentconf',
                component: SOAViewReturnToAgentConfirmationComponent
            },
            {
                path: 'soaviewsubmissionconf/:BeneficaryEmail',
                component: SOAFormSubmissionConfirmationComponent

            },
            {
                path: 'soaformagentsigned',
                component: SOAFormEmailLinkAgentSignedComponent

            },
            {
                path: 'soaformagentexpired',
                component: SOAFormEmailLinkAgentExpiredComponent

            },
            {
                path: 'submitsoa-external/:ak/:eid',
                component: SubmitElectronicSOAComponent

            }
        ]
    }
]

